// extracted by mini-css-extract-plugin
export default {"container":"mbKyhH","noSpacing":"hYUP9L"};